import { styles, variants, TextFieldTheme } from '../TextFieldStyles.css';
import { baseTheme } from './TextFieldBaseTheme.css';
import { multiVariantStyles } from './TextFieldVariants.css';

const TextFieldStableTheme: TextFieldTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TextFieldStableTheme };
